import React, { Component } from 'react';
import { changeEndDates, getCampaigns } from '../../redux/campaignActions';
import { Button, DatePicker, Modal } from '../../../../common/components';
import { closeModal } from '../../../../common/components/Modal/ModalRedux';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
//import './style.scss'

const FORM_NAME = 'amendCampaignEndDateModal';

class AmendCampaignEndDateModal extends Component {
  componentWillUpdate(newProps) {
    const { dispatch, callback, reset, campaign } = this.props;
    if (newProps.campaign.submitSucceeded && !campaign.submitSucceeded) {
      if (callback) {
        callback('');
      }
      dispatch(reset(FORM_NAME));
      dispatch(closeModal(FORM_NAME));
    }
  }

  handleSubmit(values) {
    const { campaignIds, dispatch } = this.props;
    Promise.resolve(dispatch(changeEndDates(campaignIds, values.meta.to_date))).then(
      () => {
        dispatch(getCampaigns(campaignIds));
      },
    );
  }

  render() {
    const { isSaving, handleSubmit } = this.props;
    const submitButton = (
      <Button
        type="submit"
        className="pull-right settings-button"
        bsStyle="danger"
        label="Apply"
        disabled={isSaving}
        isLoading={isSaving}
      />
    );

    return (
      <div>
        <Modal
          name={FORM_NAME}
          title="Change End Date"
          close={true}
          handleSubmit={handleSubmit(::this.handleSubmit)}
          footer={submitButton}
        >
          <div>
            <h4 id="modal-label">Change the end date to:</h4>
            <Field
              name={'meta.to_date'}
              label="dates"
              labelSize={5}
              block
              showTime
              timeFormat="HH:mm"
              dateFormat={'dd/MM/yyyy HH:mm'}
              component={DatePicker}
              shouldCloseOnSelect={false}
            />
          </div>
        </Modal>
      </div>
    );
  }
}

const form = reduxForm({ form: FORM_NAME })(AmendCampaignEndDateModal);
const selector = formValueSelector(FORM_NAME);
const mapStateToProps = (state) => {
  const values = selector(state, 'meta', 'data');
  return {
    campaign: state.campaign,
    formValues: values,
  };
};

export default connect(mapStateToProps)(form);
